import * as React from 'react';
import { DayPickerContext } from './DayPickerContext';
/**
 * Hook to access the [[DayPickerContext]].
 *
 * To use this hook make sure to wrap the components with a one
 * [[DayPickerProvider]].
 * */
export function useDayPicker() {
    var context = React.useContext(DayPickerContext);
    if (!context) {
        throw new Error("Context is not defined. useDayPicker must be used within a DayPickerProvider with a valid values.");
    }
    return context;
}
//# sourceMappingURL=useDayPicker.js.map